/* ==========================================================================
   Makefield — policy pages
   --------------------------------------------------------------------------
   The design sets the first word of a policy title outlined and the rest
   solid ("REFUND policy", "PRIVACY policy"). Shopify renders that <h1> as a
   plain text node with no Liquid to edit, so the split is done here.

   Without JS the title simply renders solid white, which is still correct and
   legible — the outline is decoration, not meaning.
   ========================================================================== */

(function () {
  'use strict';

  function splitTitle() {
    var h1 = document.querySelector('.shopify-policy__title h1');
    if (!h1 || h1.dataset.mkSplit === 'true') return;

    var words = h1.textContent.trim().split(/\s+/);
    if (words.length < 2) return;

    /* Only the first word is outlined; everything after it stays solid. */
    var first = document.createElement('em');
    first.className = 'mk-policy__outline';
    first.textContent = words[0];

    h1.textContent = '';
    h1.appendChild(first);
    h1.appendChild(document.createTextNode(' ' + words.slice(1).join(' ')));
    h1.dataset.mkSplit = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', splitTitle, { once: true });
  } else {
    splitTitle();
  }
})();
